"use client";

import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { routing } from "@/i18n/routing";

// Renders one button per configured locale by mapping routing.locales, so a
// third language appears automatically. Switching keeps the current path and
// next-intl persists the choice to the NEXT_LOCALE cookie.
export default function LanguageSwitcher({ className = "" }) {
  const t = useTranslations("common.language");
  const activeLocale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const switchTo = (locale) => {
    if (locale === activeLocale) return;
    router.replace(pathname, { locale });
  };

  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      role="group"
      aria-label={t("label")}
    >
      {routing.locales.map((locale) => (
        <button
          key={locale}
          type="button"
          onClick={() => switchTo(locale)}
          aria-current={locale === activeLocale ? "true" : undefined}
          className={`cursor-pointer rounded-md px-2 py-1 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-blue ${
            locale === activeLocale
              ? "text-white"
              : "text-white/50 hover:text-white/80"
          }`}
        >
          {t(locale)}
        </button>
      ))}
    </div>
  );
}
